import React from 'react';
import PropTypes from 'prop-types';
import css from './Checkbox.css';

const Checkbox = (props) => {
    return (
            <input
                id={props.id}
                type="checkbox"
                checked={props.checked}
                onChange={() => props.onChange(props.id, !props.checked)}
                className={css['checkbox']}
                aria-label={props.name}
                value={props.value}
                name={props.name}
                data-testid={`checkbox${props.name.replace(/\s+/g, '')}`}
            />
    );
}

Checkbox.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired
};

export default Checkbox;
